import { create } from 'zustand';

interface FeedbackState {
  isModalOpen: boolean;
  isNewFeedbackOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  openNewFeedback: () => void;
  closeNewFeedback: () => void;
}

export const useFeedbackStore = create<FeedbackState>((set) => ({
  isModalOpen: false,
  isNewFeedbackOpen: false,
  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false }),
  openNewFeedback: () => set({ isNewFeedbackOpen: true }),
  closeNewFeedback: () => set({ isNewFeedbackOpen: false }),
}));
